import Plugin from '../core/Plugin';

// QuillKit Plugin: InsertPlugin
// Combines Link, Image, Symbol, TeX, and ML into a single dropdown

class InsertPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'InsertPlugin';
    this.enabled = true; // Force enabled
  }

  getToolbarButtons() {
    // Return a toolbar group with a dropdown styled like other toolbar dropdowns
    return [
      {
        name: 'insert',
        dropdown: {
          command: 'insert',
          label: 'Insert...',
          title: 'Insert...',
          className: 'quillkit-toolbar-insert',
          options: [
            { value: 'link', label: 'Link' },
            { value: 'image', label: 'Image' },
            { value: 'symbol', label: 'Symbol' },
            { value: 'tex', label: 'TeX' },
            { value: 'ml', label: 'ML' },
            { value: 'pageBreak', label: 'Page Break' },
          ],
        },
      },
    ];
  }
}

export default InsertPlugin;
